import { render, staticRenderFns } from "./BmvBadge.vue?vue&type=template&id=336ac0a9&scoped=true"
import script from "./BmvBadge.vue?vue&type=script&lang=js"
export * from "./BmvBadge.vue?vue&type=script&lang=js"
import style0 from "./BmvBadge.vue?vue&type=style&index=0&id=336ac0a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336ac0a9",
  null
  
)

export default component.exports